<template>
  <div class="-left-bar-preview">
    <pages-list />
    <transition-panel v-if="transitionPresets.length" />
    <overlay-media-picker v-if="overlayTracks.length" />
  </div>
</template>

<script>
/** (GW)
 * Asset Editor's pages + overlay assets Vue (left bar)
 */
import PagesList from './OverlayList.vue';
import TransitionPanel from '../Info/TransitionPanel.vue';
import OverlayMediaPicker from './OverlayMediaPicker.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    TransitionPanel,
    PagesList,
    OverlayMediaPicker,
  },

  computed: {
    ...mapGetters('assetEditor', ['workModel']),
    ...mapState('assetEditor', {
      transitionPresets: (state) => state.themeInfo.transitionPresets,
    }),

    overlayTracks() {
      return this.workModel.overlayTracks || [];
    },
  },
};
</script>
